import React from "react";
import { toast } from "react-toastify";
import { DeleteStaffAPI } from "../../../../utils/APIs/staffsApis";
// import "./StaffModal.css";

const DeleteStaffModal = ({ isOpen, onClose, staff, refreshData }) => {
  if (!isOpen || !staff) return null;

  const handleDelete = async () => {
    try {
      const res = await DeleteStaffAPI(staff._id);

      if (res?.data?.success) {
        toast.success("Staff deleted");
        refreshData();
        onClose();
      }
    } catch {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>Delete Staff</h3>
        <p>Are you sure you want to delete <b>{staff.name}</b>?</p>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn-danger" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteStaffModal;
